import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ css, token }) => ({
  root: css`
    display: inline-flex !important;
    align-items: center;
    gap: 8px;
    margin-inline-start: 0 !important;
  `,

  secondary: css`
    background-color: ${token.buttonSecondaryBg} !important;
    border-color: ${token.buttonSecondaryBorderColor} !important;
    color: ${token.buttonSecondaryColor} !important;

    &:not(:disabled):hover {
      background-color: ${token.buttonSecondaryHoverBg} !important;
      border-color: ${token.buttonSecondaryHoverBorderColor} !important;
      color: ${token.buttonSecondaryColor} !important;
    }

    &:not(:disabled):active {
      background-color: ${token.buttonSecondaryActiveBg} !important;
    }

    &:disabled {
      background-color: ${token.buttonDisabledBg} !important;
      border-color: ${token.buttonDisabledBorderColor} !important;
      color: ${token.buttonDisabledColor} !important;
    }
  `,

  tertiary: css`
    background-color: ${token.buttonTertiaryBg} !important;
    border-color: ${token.buttonTertiaryBorderColor} !important;
    color: ${token.buttonTertiaryColor} !important;

    &:not(:disabled):hover {
      background-color: ${token.buttonTertiaryHoverBg} !important;
      border-color: ${token.buttonTertiaryHoverBorderColor} !important;
      color: ${token.buttonTertiaryColor} !important;
    }

    &:not(:disabled):active {
      background-color: ${token.buttonTertiaryActiveBg} !important;
    }

    &:disabled {
      background-color: ${token.buttonDisabledBg} !important;
      border-color: ${token.buttonDisabledBorderColor} !important;
      color: ${token.buttonDisabledColor} !important;
    }
  `,

  linkSecondaryIcon: css`
    color: ${token.buttonLinkSecondaryColor};
  `,

  iconOnlyLarge: css`
    padding-inline: 0 !important;
    width: ${token.controlHeightLG}px !important;
    justify-content: center;
  `,

  iconOnlyDefault: css`
    padding-inline: 0 !important;
    width: ${token.controlHeight}px !important;
    justify-content: center;
  `,

  iconOnlySmall: css`
    padding-inline: 0 !important;
    min-height: 24px !important;
    height: 24px !important;
    width: 24px !important;
    justify-content: center;
  `,

  iconWrapper: css`
    display: inline-flex;
    align-items: center;
    font-size: 16px;
    line-height: 1;
  `
}))
